/**
 * Use Case Explorer - Sector-Based Case Studies
 */
import {
    faShoppingCart,
    faHeartPulse,
    faTruck,
    faIndustry,
    faShoePrints,
    faSquareParking,
    faFlask,
    faStore,
    faChartPie,
    faUserMd,
    faFileContract,
    faWheatAwn,
    faTrain,
    faUserShield,
    faHeadset,
    faBolt,
    faShip,
    faUsers,
    faNetworkWired,
    faHardHat, faBrain
} from '@fortawesome/free-solid-svg-icons';

export const adventUseCases = [
    {
        day: 1,
        title: "Diagnosing Late Orders",
        category: "Retail",
        type: "Diagnostic",
        icon: faShoppingCart,
        summary: "Why are my orders dropping by 50%?",
        content: "Model the order and inventory flows to discover why order rates have dropped and identify hidden bottlenecks causing delays.",
        link: "/use-cases/late-orders-diagnosis"
    },
    {
        day: 2,
        title: "Tariff Impact Modelling",
        category: "Manufacturing",
        type: "Simulation",
        icon: faShoePrints,
        color: "#2f5597",
        summary: "What is the impact of new tariffs across my multi-country supply chains?",
        content: "Simulate tariff scenarios across multi-country supply chains to optimise costs, pricing, and market strategy in real-time.",
        link: "/use-cases/tariff-impact-modelling"
    },
    {
        day: 3,
        title: "Patient Flow Optimisation",
        category: "Healthcare",
        type: "Optimisation",
        icon: faHeartPulse,
        summary: "How can we reduce A&E wait times by 40%?",
        content: "Model patient flow from A&E to discharge, simulating interventions like morning discharge protocols to identify whether delayed discharges, not capacity, are causing wait times.",
        link: "/use-cases/patient-flow-optimisation"
    },
    {
        day: 4,
        title: "Route Optimisation",
        category: "Transport/Property",
        type: "Optimisation",
        icon: faTruck,
        summary: "How can we achieve 15% fuel savings?",
        content: "Map  fleet routes and logistics to identify consolidation opportunities, reduce mileage, and optimise delivery schedules.",
        link: "/use-cases/route-optimisation"
    },
    {
        day: 5,
        title: "Legacy System Risk Mitigation",
        category: "Transport/Property",
        type: "Diagnostic",
        icon: faSquareParking,
        summary: "How can we safely migrate away from our black box booking system?",
        content: "How to reverse engineer a legacy system's behaviour, map its hidden business processes and rules, and simulate migration scenarios to de-risk your platform transformation.",
        link: "/use-cases/legacy-system-risk-mitigation"
    },
    {
        day: 6,
        title: "Risk Model Rapid Prototyping",
        category: "Finance",
        type: "Simulation",
        icon: faFlask,
        summary: "How can we reduce credit risk model development from months to weeks?",
        content: "We can create secure sandbox environments with direct data access, pre-built ML templates, and visual model building tools to accelerate hypothesis testing and validation before production deployment.",
        link: "/use-cases/risk-model-rapid-prototyping"
    },
    {
        day: 7,
        title: "In-Store Customer Flow Optimisation",
        category: "Retail",
        type: "Optimisation",
        icon: faStore,
        summary: "How can we increase revenue per square foot by 15% without changing store layout?",
        content: "We can model customer movement patterns using traffic sensors and POS data, simulating product placement changes to optimise flow and maximise engagement in high-margin zones.",
        link: "/use-cases/customer-flow-optimisation"
    },
    // {
    //     day: 8,
    //     title: "Pension Fund Portfolio Analyser",
    //     category: "Finance",
    //     type: "Simulation",
    //     icon: faChartPie,
    //     summary: "How can we use AI and natural language to allow pension fund managers to rebalance their portfolios?",
    //     content: "An AI conversational interface over a pension fund structure, enabling managers to explore allocations, run what-if scenarios, and simulate rebalancing decisions with full ESG scoring and risk visibility.",
    //     link: "/use-cases/pension-fund-analyser"
    // },
    {
        day: 8,
        title: "Surgical Outcome Analytics",
        category: "Healthcare",
        type: "Diagnostic",
        icon: faUserMd,
        summary: "How can we improve surgical outcomes by connecting equipment, EMR, and planning data?",
        content: "Unified surgical analytics Twin that combines microscope telemetry, patient records, and procedure plans to deliver predictive insights for surgeons, maintenance teams, and hospital administrators.",
        link: "/use-cases/surgical-outcome-analytics"
    },
    {
        day: 9,
        title: "AI-Powered Insurance Claims Processing",
        category: "Finance",
        type: "Optimisation",
        icon: faFileContract,
        summary: "How can we reduce claims processing time by 70% while improving accuracy?",
        content: "An intelligent claims workbench for an property insurance company that combines document extraction, damage assessment, fraud detection, and settlement recommendations-enabling claims officers to process more claims with greater consistency.",
        link: "/use-cases/claims-processing-ai"
    },
    {
        day: 10,
        title: "Customer Lifetime Value Analytics",
        category: "Retail",
        type: "Diagnostic",
        icon: faChartPie,
        summary: "How can we predict and reduce customer churn by understanding lifetime value drivers?",
        content: "Unify CRM platforms (Zoho, Zendesk, Gong) with customer and order data to calculate Customer Lifetime Value through Average Order Value, Purchase Frequency, and Customer Lifespan metrics-enabling targeted retention strategies for high-value customers at risk of churning.",
        link: "/use-cases/customer-lifetime-value"
    },
    {
        day: 11,
        title: "Food Distribution Optimization",
        category: "Transport/Property",
        type: "Mission Control",
        icon: faWheatAwn,
        summary: "Making sure families get the right food they need",
        content: "An immersive command center for the World Food Programme showing real-time food distribution optimization, interactive world map, and beneficiary impact stories.",
        link: "/use-cases/food-optimisation-mission-control"
    },
    {
        day: 12,
        title: "Train Rerouting Optimization",
        category: "Transport",
        type: "Prescriptive",
        icon: faTrain,
        summary: "Optimizing routes when disruptions occur",
        content: "Graph-based analytics using Dijkstra's algorithm to calculate optimal train reroutes during incidents, minimizing passenger impact and journey delays across the network.",
        link: "/use-cases/train-rerouting"
    },
    {
        day: 13,
        title: "Production Line Resilience",
        category: "Manufacturing",
        type: "Simulation",
        icon: faIndustry,
        summary: "How do we minimize time to fix when the line goes down?",
        content: "Model your production line as a Data Object Graph, then simulate equipment failures offline to design and test new response procedures, spare parts positioning, and crew scheduling-before incidents ever occur.",
        link: "/use-cases/production-line-resilience"
    },
    {
        day: 14,
        title: "Customer Onboarding Optimisation",
        category: "Finance",
        type: "Simulation",
        icon: faUserShield,
        summary: "How do we reduce onboarding drop-off while staying compliant?",
        content: "Model your KYC and onboarding process as a Data Object Graph, then simulate changes to verification sequences, automation rules, and compliance checks offline-reducing time-to-activate from 5 days to 2 while maintaining regulatory compliance.",
        link: "/use-cases/customer-onboarding-optimisation"
    },
    {
        day: 15,
        title: "Customer Support Resolution",
        category: "Retail",
        type: "Simulation",
        icon: faHeadset,
        summary: "How do we improve first-contact resolution without adding headcount?",
        content: "Model your support workflow as connected process steps, then simulate changes to triage rules, skill-based routing, and escalation thresholds offline-improving FCR from 65% to 84% while reducing average resolution time by 35%.",
        link: "/use-cases/customer-support-resolution"
    },
    {
        day: 16,
        title: "Energy Grid Load Balancing",
        category: "Utilities",
        type: "Simulation",
        icon: faBolt,
        summary: "How do we handle peak demand without blackouts?",
        content: "Model your energy grid as connected generation, storage, and demand nodes. Simulate peak load scenarios, renewable intermittency, and pricing strategies offline-optimising supply mix to reduce costs by 18% while maintaining 99.9% grid stability.",
        link: "/use-cases/energy-grid-load-balancing"
    },
    {
        day: 17,
        title: "Clinical Trial Patient Flow",
        category: "Healthcare",
        type: "Simulation",
        icon: faUserMd,
        summary: "How do we accelerate recruitment and reduce dropout?",
        content: "Model your clinical trial as a patient flow network connecting protocol criteria, site capacity, and enrollment funnels. Simulate recruitment scenarios offline to identify bottlenecks, predict dropout risk, and hit enrollment targets 40% faster.",
        link: "/use-cases/clinical-trial-patient-flow"
    },
    {
        day: 18,
        title: "Port Container Visibility",
        category: "Logistics",
        type: "Simulation",
        icon: faShip,
        summary: "Where does the data thread snap between ship and shore?",
        content: "Model your port ecosystem as connected shipping lines, terminals, customs, and transport systems. Simulate container handoffs to find visibility gaps, predict dwell time, and rebuild the digital thread-cutting demurrage costs by 35% and delays by 60%.",
        link: "/use-cases/port-container-visibility"
    },{
        day: 19,
        title: "Workforce Capacity Planning",
        category: "HR Operations",
        type: "Simulation",
        icon: faUsers,
        summary: "Do we have the right skills for next quarter?",
        content: "Model your workforce as a skills network connecting people, projects, and demand forecasts. Simulate hiring, training, and attrition scenarios offline to identify capability gaps, optimise resource allocation, and hit delivery targets,before skill shortages derail projects.",
        link: "/use-cases/workforce-capacity-planning"
    },
    {
        day: 20,
        title: "IT Asset Dependency Mapping",
        category: "Technology",
        type: "Simulation",
        icon: faNetworkWired,
        summary: "If this system goes down, what else breaks?",
        content: "Model your IT estate as a dependency graph connecting software, hardware, and data center components. Simulate failures offline to understand cascade effects and prioritise resilience investments-before incidents occur.",
        link: "/use-cases/it-asset-dependency-mapping"
    },
    {
        day: 21,
        title: "Construction Project Risk",
        category: "Construction",
        type: "Simulation",
        icon: faHardHat,
        summary: "Which projects will overrun budget or schedule?",
        content: "Model your construction portfolio as connected schedules, budgets, and risk factors. Simulate delays, change orders, and resource constraints offline to predict overruns, prioritise interventions, and deliver projects on time and on budget.",
        link: "/use-cases/construction-project-risk"
    },
    {
        day: 22,
        title: "AI Readiness Assessment",
        category: "Strategy",
        type: "Simulation",
        icon: faBrain,
        summary: "Where should we deploy AI first?",
        content: "Model your organisation as connected processes, data assets, and capabilities. Simulate AI deployment scenarios offline to find high-value use cases, identify blockers, and build a prioritised roadmap-before committing millions to the wrong pilots.",
        link: "/use-cases/ai-readiness-assessment"
    }
    // {
    //     day: 24,
    //     title: "Santa's Route Optimizer",
    //     category: "Christmas",
    //     type: "Simulation",
    //     icon: faGift,
    //     summary: "How does Santa deliver to everyone in one night?",
    //     content: "Model the village as a connected graph of houses, roads, and delivery priorities. Simulate routing algorithms in real-time to find the optimal path-delivering joy to every home before sunrise.",
    //     link: "/use-cases/santas-route-optimizer"
    // }
];

export const categoryColors = {
    "Retail": { bg: "rgba(112, 48, 160, 0.1)", border: "#7030a0", text: "#7030a0" },
    "Finance": { bg: "rgba(47, 85, 151, 0.1)", border: "#2f5597", text: "#2f5597" },
    "Healthcare": { bg: "rgba(0, 128, 128, 0.1)", border: "#008080", text: "#008080" },
    "Transport/Property": { bg: "rgba(139, 69, 19, 0.1)", border: "#8B4513", text: "#8B4513" },
    "Manufacturing": { bg: "rgba(196, 30, 58, 0.1)", border: "#c41e3a", text: "#c41e3a" },
    "Oil & Gas": { bg: "rgba(0, 100, 100, 0.1)", border: "yellow", text: "#c41e3a" },
    "Technology": { bg: "rgba(0, 255, 0, 0.1)", border: "green", text: "#c41e3a" },
    "Utilities": { bg: "rgba(0, 255, 0, 0.1)", border: "lightseagreen", text: "#c41e3a" },
    "Construction": { bg: "rgba(0, 255, 0, 0.1)", border: "Darkmagenta", text: "#c41e3a" },
    "Strategy": { bg: "rgba(0, 255, 0, 0.1)", border: "Lightsalmon", text: "#c41e3a" },
    "Christmas": { bg: "rgba(0, 255, 0, 0.1)", border: "Red", text: "#c41e3a" },

};

export const typeColors = {
    "Diagnostic": { bg: "rgba(220, 53, 69, 0.1)", border: "#dc3545", text: "#dc3545" },
    "Optimisation": { bg: "rgba(40, 167, 69, 0.1)", border: "#28a745", text: "#28a745" },
    "Simulation": { bg: "rgba(47, 85, 151, 0.1)", border: "#2f5597", text: "#2f5597" },
    "Forecasting": { bg: "rgba(112, 48, 160, 0.1)", border: "#7030a0", text: "#7030a0" }
};